const selectors = {
  defaultClassInfo: (state) => state.createClass.defaultClassInfo,
  submitCreationStatus: (state) => state.createClass.submitCreationStatus,
};

export { selectors };
